import(/* webpackMode: "eager" */ "/home/u771446010/domains/dev.jbcodeapp.in/hbuilds/source/repository/app/global-error.tsx");
